import { useEffect } from 'react';
import { toast } from 'sonner';
import { usePWA } from '@/hooks/usePWA';

export function PWAUpdateToast() {
  const { updateAvailable, updateServiceWorker } = usePWA();

  useEffect(() => {
    if (updateAvailable) {
      console.log('🔔 Showing update toast');
      toast.info('Nova versão disponível!', {
        id: 'pwa-update-toast', // Prevent duplicates
        description: 'Uma nova versão do app está pronta para ser instalada.',
        action: {
          label: 'Atualizar agora',
          onClick: () => {
            console.log('🖱️ User clicked update');
            updateServiceWorker();
          }
        },
        duration: Infinity, // Don't auto-dismiss
        onDismiss: () => {
          console.log('❌ Update toast dismissed');
        },
        cancel: {
          label: 'Depois',
          onClick: () => console.log('👋 Update postponed')
        }
      });
    }
  }, [updateAvailable, updateServiceWorker]);

  return null;
}
